import { memo } from 'react';
import { Tabs } from '@wg/wows-react-uikit';

import { t } from '~/helpers/localization';

import styles from './DivisionTabs.scss';

import type { LeagueItemDivision } from '~/types/declaration';

interface IDivisionTabsProps {
  items: LeagueItemDivision[];
  selected: number;
  onDivisionChange: (division: number) => void;
}

const DivisionTabs = ({ items, selected, onDivisionChange }: IDivisionTabsProps) => {
  const tabs = items.map((tab) => ({
    value: tab.number,
    content: (
      <div key={tab.number}>
        <div className={styles.divisionNumber}>{tab.title}</div>
        <div className={styles.smallText}>{t('Дивизион')}</div>
      </div>
    ),
  }));

  return (
    <div className={styles.container}>
      <Tabs tabs={tabs} tabSelected={selected} onToggleTab={onDivisionChange} />
    </div>
  );
};

export default memo(DivisionTabs);
